import { render, staticRenderFns } from "./MenuRouteManage.vue?vue&type=template&id=58cef548&scoped=true"
import script from "./MenuRouteManage.vue?vue&type=script&lang=js"
export * from "./MenuRouteManage.vue?vue&type=script&lang=js"
import style0 from "./MenuRouteManage.vue?vue&type=style&index=0&id=58cef548&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cef548",
  null
  
)

export default component.exports